import { render, staticRenderFns } from "./ArabicAboutUs.vue?vue&type=template&id=25d9cd80&scoped=true"
import script from "./ArabicAboutUs.vue?vue&type=script&lang=js"
export * from "./ArabicAboutUs.vue?vue&type=script&lang=js"
import style0 from "./ArabicAboutUs.vue?vue&type=style&index=0&id=25d9cd80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d9cd80",
  null
  
)

export default component.exports